import type { FeatureFlag, FeatureFlagCategory_Config } from './types';

export const FLAG_CATEGORIES: FeatureFlagCategory_Config[] = [
  {
    value: 'core',
    label: 'Alap funkciók',
    icon: '⚙️',
    color: 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300',
  },
  {
    value: 'rental',
    label: 'Bérlés',
    icon: '📦',
    color: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300',
  },
  {
    value: 'service',
    label: 'Szerviz',
    icon: '🔧',
    color: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300',
  },
  {
    value: 'sales',
    label: 'Értékesítés',
    icon: '🛒',
    color: 'bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-300',
  },
  {
    value: 'integration',
    label: 'Integrációk',
    icon: '🔗',
    color: 'bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-300',
  },
  {
    value: 'experimental',
    label: 'Kísérleti',
    icon: '🧪',
    color: 'bg-pink-100 text-pink-800 dark:bg-pink-900/30 dark:text-pink-300',
  },
];

export const MOCK_FEATURE_FLAGS: FeatureFlag[] = [
  // Core
  {
    id: 'flag-1',
    key: 'dark_mode',
    name: 'Sötét mód',
    description: 'Sötét téma engedélyezése a felhasználói felületen',
    category: 'core',
    enabled: true,
    updatedAt: '2024-01-15T10:00:00Z',
    updatedBy: 'admin',
  },
  {
    id: 'flag-2',
    key: 'offline_mode',
    name: 'Offline működés',
    description: 'PWA offline mód engedélyezése lokális adattárolással',
    category: 'core',
    enabled: true,
    updatedAt: '2024-01-10T08:00:00Z',
    updatedBy: 'admin',
  },
  {
    id: 'flag-3',
    key: 'multi_language',
    name: 'Többnyelvűség',
    description: 'Többnyelvű felület (magyar, angol)',
    category: 'core',
    enabled: false,
    updatedAt: '2024-01-05T14:00:00Z',
  },

  // Rental
  {
    id: 'flag-4',
    key: 'rental_deposit_mypos',
    name: 'MyPOS kaució',
    description: 'Kaució befoglalás MyPOS terminálon keresztül',
    category: 'rental',
    enabled: true,
    updatedAt: '2024-01-18T09:00:00Z',
    updatedBy: 'admin',
  },
  {
    id: 'flag-5',
    key: 'rental_late_fee',
    name: 'Késedelmi díj',
    description: 'Automatikus késedelmi díj számítás késett visszahozásnál',
    category: 'rental',
    enabled: true,
    updatedAt: '2024-01-12T11:00:00Z',
  },
  {
    id: 'flag-6',
    key: 'rental_long_term',
    name: 'Hosszú távú bérlés',
    description: 'Havi/éves bérlési szerződések kezelése',
    category: 'rental',
    enabled: true,
    isNew: true,
    updatedAt: '2024-01-17T16:00:00Z',
  },
  {
    id: 'flag-7',
    key: 'rental_reservation',
    name: 'Előfoglalás',
    description: 'Gépek előzetes lefoglalása adott időpontra',
    category: 'rental',
    enabled: false,
    isBeta: true,
    updatedAt: '2024-01-08T10:00:00Z',
  },

  // Service
  {
    id: 'flag-8',
    key: 'service_makita_norma',
    name: 'Makita norma',
    description: 'Makita szerviz normaóra kalkuláció',
    category: 'service',
    enabled: true,
    updatedAt: '2024-01-14T12:00:00Z',
  },
  {
    id: 'flag-9',
    key: 'service_warranty_auto',
    name: 'Automatikus garancia',
    description: 'Automatikus garanciális státusz ellenőrzés gyári adatbázisból',
    category: 'service',
    enabled: false,
    isBeta: true,
    updatedAt: '2024-01-06T09:00:00Z',
  },
  {
    id: 'flag-10',
    key: 'service_parts_ordering',
    name: 'Alkatrész rendelés',
    description: 'Közvetlen alkatrész rendelés beszállítótól munkalapról',
    category: 'service',
    enabled: true,
    updatedAt: '2024-01-16T14:00:00Z',
  },

  // Sales
  {
    id: 'flag-11',
    key: 'sales_pos_scanner',
    name: 'Vonalkód olvasó',
    description: 'Vonalkód olvasó támogatás POS-on',
    category: 'sales',
    enabled: true,
    updatedAt: '2024-01-11T10:00:00Z',
  },
  {
    id: 'flag-12',
    key: 'sales_discount_codes',
    name: 'Kedvezmény kódok',
    description: 'Kuponkódok és kedvezmények kezelése',
    category: 'sales',
    enabled: false,
    updatedAt: '2024-01-03T08:00:00Z',
  },
  {
    id: 'flag-13',
    key: 'sales_quotation',
    name: 'Árajánlat modul',
    description: 'Árajánlatok készítése és nyomon követése',
    category: 'sales',
    enabled: true,
    isNew: true,
    updatedAt: '2024-01-18T11:00:00Z',
  },

  // Integration
  {
    id: 'flag-14',
    key: 'integration_nav_online',
    name: 'NAV Online számla',
    description: 'Automatikus számla beküldés NAV Online rendszerbe',
    category: 'integration',
    enabled: true,
    updatedAt: '2024-01-15T15:00:00Z',
  },
  {
    id: 'flag-15',
    key: 'integration_szamlazz_hu',
    name: 'Számlázz.hu',
    description: 'Számlázz.hu API integráció',
    category: 'integration',
    enabled: true,
    dependencies: ['integration_nav_online'],
    updatedAt: '2024-01-15T15:30:00Z',
  },
  {
    id: 'flag-16',
    key: 'integration_twenty_crm',
    name: 'Twenty CRM',
    description: 'Twenty CRM integráció ügyfélkezeléshez',
    category: 'integration',
    enabled: false,
    isBeta: true,
    updatedAt: '2024-01-07T12:00:00Z',
  },
  {
    id: 'flag-17',
    key: 'integration_chatwoot',
    name: 'Chatwoot',
    description: 'Chatwoot integráció ügyfélszolgálathoz',
    category: 'integration',
    enabled: false,
    updatedAt: '2024-01-04T10:00:00Z',
  },

  // Experimental
  {
    id: 'flag-18',
    key: 'experimental_ai_pricing',
    name: 'AI árazás',
    description: 'Mesterséges intelligencia alapú dinamikus árazás',
    category: 'experimental',
    enabled: false,
    isBeta: true,
    updatedAt: '2024-01-02T08:00:00Z',
  },
  {
    id: 'flag-19',
    key: 'experimental_voice_search',
    name: 'Hangalapú keresés',
    description: 'Hangvezérelt keresés és parancsok',
    category: 'experimental',
    enabled: false,
    isBeta: true,
    updatedAt: '2024-01-01T10:00:00Z',
  },
  {
    id: 'flag-20',
    key: 'experimental_predictive_maintenance',
    name: 'Prediktív karbantartás',
    description: 'Gépek várható karbantartási igényének előrejelzése',
    category: 'experimental',
    enabled: false,
    isBeta: true,
    isNew: true,
    updatedAt: '2024-01-17T09:00:00Z',
  },
];
